import _ from 'lodash'
import moment from 'moment'

function getFilteredEventsForDateRange(eventsData, activeCategory, activeStartDate, activeEndDate = null) {
  let events = null
  let dailyEvents = []

  if (eventsData && eventsData.data && !_.isEmpty(eventsData.data.events)) {
    for (const eventKey in eventsData.data.events) {
      const currentEvent = eventsData.data.events[eventKey]

      if (currentEvent && currentEvent.title && currentEvent.schedule) {
        for (const scheduleKey in currentEvent.schedule) {
          const eventStartDate = _.get(currentEvent, `schedule[${scheduleKey}].startDate`)
          // if no activeEndDate provided, consider range to be a single day
          // and use activeStartDate 
          const endDate = activeEndDate || activeStartDate
          if (
            moment(eventStartDate).isSameOrAfter(activeStartDate, 'day')
            && moment(eventStartDate).isSameOrBefore(endDate, 'day')
          ) {
            const currentSchedule = currentEvent.schedule[scheduleKey]
            const startDate = _.get(currentSchedule, 'startDate', null)
            const endDate = _.get(currentSchedule, 'endDate', null)

            const formattedEvent = {
              ...currentEvent,
              activeDates: {
                startDate: startDate,
                endDate: endDate
              }
            }

            dailyEvents.push(formattedEvent)
            events = dailyEvents

            if (activeCategory !== '' && !_.isEmpty(events)) {
              let filteredEvents = []

              events.forEach(event => {
                if (_.includes(event.categories, activeCategory)) {
                  filteredEvents.push(event)
                }
              })

              events = filteredEvents
            }
          }
        }
      }
    }
  }

  return events
}

export default getFilteredEventsForDateRange
